import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useJournalCreate } from '@/module/Journal/model/JournalQuery';
import { JournalSchema, defaultJournalValues, journalSchema } from '@/module/Journal/model/JournalSchema';

import { useAppNotification } from '@feature/utils';

import { JournalForm } from './JournalForm';

export function JournalCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useJournalCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: JournalSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newJournal => {
        notification.success();
        navigate({ to: '/journal/$journalId', params: { journalId: String(newJournal.id) } });
      },
    });
  };

  return (
    <JournalForm
      title={t('journals.form.title.create')}
      schema={journalSchema}
      defaultValues={defaultJournalValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
